import { HOTJAR_EVENTS } from '../events-tracker/consts'

type HotjarEvent = (typeof HOTJAR_EVENTS)[keyof typeof HOTJAR_EVENTS]

declare global {
  interface Window {
    hj: ((type: string, eventName: HotjarEvent) => void) | undefined
  }
}

export const trackHotjarEvent = (eventName: HotjarEvent) => {
  if (!window.hj) {
    console.error('The Hotjar script could not be found.')
    return
  }

  window.hj('event', eventName)
}
